import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import servicesData from "../data/servicesData";
import { useEffect } from "react";

function AllServices() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<section className="allServicesSection servicesSection desktopMaxWidth">
			<div className="servicesTitleContainer">
				<p className="tag">Services</p>
				<p className="servicesTitle">
					A comprehensive Range of Counseling Services
				</p>
			</div>

			<div className="servicesContainer">
				{Object.entries(servicesData).map(([key, service], index) => (
					<Link to={`/services/${key}`} key={index}>
						<ServiceCard
							icon={service.icon}
							title={service.title}
							text={service.text}
						/>
					</Link>
				))}
			</div>
		</section>
	);
}

export default AllServices;
